import { ExternalLink, MonitorSmartphone } from "lucide-react";
import { AppShell } from "@/components/AppShell";
import { USER_NAV } from "@/pages/userNav";
import { useLanguage } from "@/context/LanguageContext";

const MT_LINK = "https://web.metatrader.app/terminal?mode=demo&lang=en";

export default function DemoAccountPage() {
  const { t } = useLanguage();

  const platforms = [
    { key: "mt4", label: "MetaTrader 4", text: t("demo.mt4Desc") },
    { key: "mt5", label: "MetaTrader 5", text: t("demo.mt5Desc") },
  ];

  return (
    <AppShell nav={USER_NAV} title={t("demo.title")} subtitle={t("demo.subtitle")}>
      <div data-testid="demo-account-page" className="max-w-3xl space-y-6">
        <section className="rounded-md border border-[#22252F] bg-[#12141A] p-6">
          <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#60A5FA]">
            <MonitorSmartphone className="h-3.5 w-3.5" /> {t("demo.badge")}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-[#94A3B8]">{t("demo.intro")}</p>
        </section>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {platforms.map((p) => (
            <section key={p.key} className="rounded-md border border-[#22252F] bg-[#12141A] p-6">
              <h2 className="text-base text-white md:text-lg">{p.label}</h2>
              <p className="mt-2 text-sm text-[#94A3B8]">{p.text}</p>
              <a
                href={MT_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid={`open-${p.key}-button`}
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#2563EB] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#1D4ED8]"
              >
                <ExternalLink className="h-4 w-4" /> {t("demo.open")} {p.label}
              </a>
            </section>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
